// Firebase configuration
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDMchnepoCfJwXTETkxgFNDwLckeV0UoHc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "booklearnin-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "booklearnin-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "booklearnin-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "35216111622",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:35216111622:web:369fee49b109b1e3862b87",
  measurementId: "G-01MQ9YX0B9", // Required for Firebase Analytics
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Analytics only in browser environment
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Log analytics status for debugging (only in browser)
if (typeof window !== 'undefined') {
  console.log(`Firebase Analytics initialized for environment: ${process.env.NODE_ENV} with measurement ID: ${firebaseConfig.measurementId}`);
}

// Stripe configuration for future payment integration
export const stripeConfig = {
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
}; 